module.exports = "/lucky-balls/img/drawnballs/green.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/drawnballs/green.png
// module id = 1011
// module chunks = 0